import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';

export const compensationApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    compensationList: builder.query<
      SharesproApiResponse<CompensationResponse>,
      ApiCompensationRequest
    >({
      query: (params) => ({
        url: '/v3/finance/compensation',
        method: 'GET',
        params,
        sendToken: true,
      }),
      transformResponse: (
        baseQueryReturnValue: SharesproApiResponse<CompensationResponse>
      ) => {
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const { useCompensationListQuery } = compensationApi;
